import * as ngCore from '@angular/core'
import * as ngMatDatepicker from '@angular/material/datepicker'
import type { Range } from '@attain-apps/range'

import * as config from '../../../../config'
import * as text from '../../text'

/** TODO */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [ngMatDatepicker.MatDatepickerModule, text.Component],
  providers: [...config.dateFormat.DATE_MATERIAL_PROVIDERS],
  selector: 'atn-ds-date-range-input',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Holds the selected date range input value. */
  public readonly valueSg = ngCore.input.required<Range<Date> | undefined>({
    alias: 'value',
  })

  /** Exposes the start date of the currently selected date range */
  public readonly startDateSg = ngCore.computed(
    (dateRange = this.valueSg()) => dateRange?.start,
  )

  /** Exposes the end date of the currently selected date range */
  public readonly endDateSg = ngCore.computed(
    (dateRange = this.valueSg()) => dateRange?.end,
  )

  /** {@link ngMatDatepicker.MatDateRangePicker} */
  public readonly rangePickerSg = ngCore.input.required<
    ngMatDatepicker.MatDateRangePicker<Date>
  >({
    alias: 'rangePicker',
  })
}
